__turbopack_context__.v({
  "copy": "BlockStaticAlertBar-module-scss-module__oQ3Q3q__copy",
  "inner": "BlockStaticAlertBar-module-scss-module__oQ3Q3q__inner",
  "root": "BlockStaticAlertBar-module-scss-module__oQ3Q3q__root",
});
